module.exports = __webpack_public_path__ + "img/IMG-20200229-WA0134.ebd1eb85.jpg";